import {createContext, ReactNode, useContext, useEffect, useState} from 'react'
import api from "../../services/api";
import {validaCPF} from "../../assets/js/helper";
import dayjs from "dayjs";
import {AuthContext} from "../AuthContext";
import {MainContext} from "../MainContext";

type Props = {
    children?: ReactNode;
}

const initialValue = {
    active: true,
    setActive: () => {},
    blocked: false,
    setBlocked: () => {},
    incompleteRegistration: 0,
    setIncompleteRegistration: () => {},
    fullName: "",
    setFullName: () => {},
    cpf: "",
    setCpf: () => {},
    rg: "",
    setRg: () => {},
    crNumber: "",
    setCrNumber: () => {},
    genre: "M",
    setGenre: () => {},
    level: "1",
    setLevel: () => {},
    phone: "",
    setPhone: () => {},
    birthDate: null,
    setBirthDate: () => {},
    crExpedition: null,
    setCrExpedition: () => {},
    crValidity: null,
    setCrValidity: () => {},
    phoneDispatcher: "",
    setPhoneDispatcher: () => {},
    emailDispatcher: "",
    setEmailDispatcher: () => {},
    arrayLevels: [],
    setArrayLevels: () => {},
    memberNumber: null,
    setMemberNumber: () => {},
    membershipDate: null,
    setMembershipDate: () => {},
    disaffiliationDate: null,
    setDisaffiliationDate: () => {},
    membershipType: "i",
    setMembershipType: () => {},
    memberActivity: [],
    setMemberActivity: () => {},
}

const AthleteContext = createContext<any>(initialValue)

const AthleteProvider = ({children}: Props) => {
    const [memberNumber, setMemberNumber] = useState(initialValue.memberNumber );
    const [membershipDate, setMembershipDate] = useState(initialValue.membershipDate);
    const [disaffiliationDate, setDisaffiliationDate] = useState(initialValue.disaffiliationDate);
    const [membershipType, setMembershipType] = useState(initialValue.membershipType as any);
    const [memberActivity, setMemberActivity] = useState(initialValue.memberActivity as any)

    const [active, setActive] = useState(initialValue.active)
    const [blocked, setBlocked] = useState(initialValue.blocked)
    const [incompleteRegistration, setIncompleteRegistration] = useState(initialValue.incompleteRegistration);
    const [fullName, setFullName] = useState(initialValue.fullName);
    const [cpf, setCpf] = useState(initialValue.cpf);
    const [rg, setRg] = useState(initialValue.rg);
    const [genre, setGenre] = useState(initialValue.genre as any);
    const [level, setLevel] = useState(initialValue.level as any);
    const [phone, setPhone] = useState(initialValue.phone);
    const [birthDate, setBirthDate] = useState(initialValue.birthDate);
    const [crNumber, setCrNumber] = useState(initialValue.crNumber);
    const [crExpedition, setCrExpedition] = useState(initialValue.crExpedition);
    const [crValidity, setCrValidity] = useState(initialValue.crValidity);
    const [phoneDispatcher, setPhoneDispatcher] = useState(initialValue.phoneDispatcher);
    const [emailDispatcher, setEmailDispatcher] = useState(initialValue.emailDispatcher);

    const [arrayLevels, setArrayLevels] = useState(initialValue.arrayLevels as any)

    const { authUser } = useContext(AuthContext)
    const { club } = useContext(MainContext)

    async function levels(value = '') {
        const response = await api.get(`/api/levels`)
        const result = await response
        return setArrayLevels(
            await result.data.map((leve:any) => ({
                label: leve.description ,
                value: leve.id
            })),
        )
    }

    const validateAthleteRegister = () => {
        if (!fullName) {
            throw "Nome completo deve ser informado";
        }

        if (!cpf) {
            throw "CPF deve ser informado";
        }

        if(!validaCPF(cpf)){
            throw "CPF inválido";
        }


        if (authUser?.role === 'athlete'){
            if (!rg) {
                throw "RG deve ser informado";
            }

            if (!phone) {
                throw "Celular deve ser informado";
            }

            if (!birthDate) {
                throw "Data de nascimento deve ser informada";
            }
        }
    }

        const dispatchAthleteObject = {
        // "address_id": addressId,

        "active": active,
        "blocked": blocked,
        "incomplete_registration": incompleteRegistration,
        "full_name": fullName,
        "birth_date": birthDate != null ? dayjs(birthDate).format('YYYY-MM-DD') : null ,
        "cpf": cpf,
        "rg": rg,
        "genre": genre,
        "phone": phone,
        "membership_date": membershipDate != null ? dayjs(membershipDate).format('YYYY-MM-DD') : null ,
        "member_number": memberNumber,
        "membership_type": membershipType,
        "disaffiliation_date": disaffiliationDate != null ? dayjs(disaffiliationDate).format('YYYY-MM-DD') : null ,
        "cr_number": crNumber,
        "cr_expedition_date": crExpedition != null ? dayjs(crExpedition).format('YYYY-MM-DD') : null ,
        "cr_validity_date": crValidity != null ? dayjs(crValidity).format('YYYY-MM-DD') : null ,
        "phone_dispatcher": phoneDispatcher,
        "email_dispatcher": emailDispatcher,
        "level_id": level,
        "club_member":{
            "membership_date": membershipDate != null ? dayjs(membershipDate).format('YYYY-MM-DD') : null ,
            "disaffiliation_date": disaffiliationDate != null ? dayjs(disaffiliationDate).format('YYYY-MM-DD') : null ,
            "member_number": memberNumber,
            "membership_type": membershipType,
            "club_id": club?.id ?? 1,
            "activity": memberActivity.map((option: { value: number; }) => option.value)
        },
        }

    useEffect(() => {
        levels()
    },  [])

    return (
        <>
            <AthleteContext.Provider value={{
                active, setActive,
                blocked, setBlocked,
                incompleteRegistration, setIncompleteRegistration,
                fullName, setFullName,
                cpf, setCpf,
                rg, setRg,
                genre, setGenre,
                phone, setPhone,
                birthDate, setBirthDate,
                level, setLevel,
                arrayLevels, setArrayLevels,
                crNumber, setCrNumber,
                crExpedition, setCrExpedition,
                crValidity, setCrValidity,
                phoneDispatcher, setPhoneDispatcher,
                emailDispatcher, setEmailDispatcher,
                memberNumber, setMemberNumber,
                membershipDate, setMembershipDate,
                memberActivity,setMemberActivity,
                membershipType, setMembershipType,
                disaffiliationDate, setDisaffiliationDate,
                dispatchAthleteObject,
                validateAthleteRegister
            }}>
                {children}
            </AthleteContext.Provider>

        </>
    )
}

export { AthleteContext, AthleteProvider }
